module.exports = __webpack_public_path__ + "static/media/Yulia Burova.3eee2740.jpg";